import PropTypes from "prop-types";
import React from "react";
import BuilderContainer from "./BuilderContainer";
import BuilderContainerProvider from "./BuilderContainerContext";

function BuilderContainerWrapper(props) {
  return (
    <BuilderContainerProvider {...props}>
      <BuilderContainer />
    </BuilderContainerProvider>
  );
}

BuilderContainerWrapper.propTypes = {
  config: PropTypes.object.isRequired,
};

export default React.memo(BuilderContainerWrapper);
